module.exports = __webpack_public_path__ + "img/agricultural-icon.076bed1a.svg";